import { Seo } from "../components/Seo";

const SECTIONS = [
    {
        h: "1. O que coletamos",
        body: "Operamos com coleta mínima de dados. Para usar as ferramentas básicas não pedimos cadastro, nome ou e-mail. Os únicos dados envolvidos são: os arquivos que você envia (apenas para processar a operação solicitada), dados técnicos de conexão (como endereço IP, usados para limites de uso e prevenção de abuso) e mensagens enviadas voluntariamente pelo formulário de contato.",
    },
    {
        h: "2. Retenção e exclusão automática",
        body: "Arquivos de entrada são descartados assim que o processamento termina. O arquivo de resultado fica disponível para download por no máximo 60 minutos e depois é excluído de forma definitiva do armazenamento. Uma rotina automática de limpeza verifica e remove qualquer arquivo que tenha passado do prazo.",
    },
    {
        h: "3. O que nunca fazemos",
        body: "Não lemos nem registramos o conteúdo dos seus documentos. Não usamos arquivos enviados para treinar modelos de IA. Não vendemos nem compartilhamos documentos com terceiros. Não usamos rastreadores de comportamento nem anúncios de terceiros.",
    },
    {
        h: "4. Base legal e LGPD",
        body: "O tratamento de dados técnicos mínimos tem como base o legítimo interesse (segurança e funcionamento do serviço) e, no caso do formulário de contato, a sua ação voluntária de nos escrever. Nos termos da Lei Geral de Proteção de Dados (Lei nº 13.709/2018), você pode solicitar confirmação, acesso, correção ou eliminação dos seus dados pessoais pelo canal de contato.",
    },
    {
        h: "5. Segurança",
        body: "As conexões usam HTTPS, os arquivos recebem nomes internos aleatórios e ficam em armazenamento privado, sem acesso público direto. Downloads exigem um token único por operação. Nenhum sistema é invulnerável: mantemos processo de atualização de dependências e resposta a incidentes.",
    },
    {
        h: "6. Seus direitos",
        body: "Você pode exercer os direitos previstos no art. 18 da LGPD (confirmação, acesso, correção, anonimização, eliminação, portabilidade e informação sobre compartilhamento) escrevendo pela página de contato. Respondemos em prazo razoável.",
    },
    {
        h: "7. Alterações desta política",
        body: "Esta política pode ser atualizada para refletir mudanças no serviço ou na legislação. A versão vigente estará sempre nesta página. Texto preparado para revisão jurídica antes da publicação definitiva.",
    },
];

export default function PrivacyPage() {
    return (
        <main className="py-14 px-6 max-w-3xl mx-auto min-h-[60vh]">
            <Seo
                title="Política de privacidade — ScorpionPDF"
                description="Coleta mínima de dados, exclusão automática de arquivos em até 60 minutos e conformidade com a LGPD."
            />
            <span className="font-mono-tag text-xs font-bold text-[#0284C7] uppercase">Documento</span>
            <h1 className="font-poster text-5xl md:text-6xl text-black mt-1">Privacidade</h1>
            <p className="text-gray-700 mt-4">
                Resumo honesto: seus arquivos existem aqui apenas pelo tempo de processar a sua tarefa — e nunca mais
                do que 60 minutos.
            </p>
            <div className="mt-10 space-y-6">
                {SECTIONS.map((s) => (
                    <section key={s.h} className="border-2 border-black bg-white p-6">
                        <h2 className="font-bold text-black">{s.h}</h2>
                        <p className="text-sm text-gray-700 mt-2 leading-relaxed">{s.body}</p>
                    </section>
                ))}
            </div>
        </main>
    );
}
